<template>
  <t-form labelWidth="100px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
    <e-collapse title="标题" :expand="false">
      <t-form-item label="标题">
        <t-input size="small" v-model="attribute.title.text" :maxcharacter="52"/>
      </t-form-item>
      <t-form-item label="标题大小">
        <t-input-number size="small" v-model="attribute.title.textStyle.fontSize" :min="10" :max="50" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="标题颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.title.textStyle.color"/>
      </t-form-item>
      <t-form-item label="标题位置(X)">
        <e-chart-position v-model="attribute.title.left" :direction="'x'"/>
      </t-form-item>
      <t-form-item label="标题位置(Y)">
        <e-chart-position v-model="attribute.title.top" :direction="'y'"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="图例" :expand="false">
      <t-form-item label="显示">
        <t-switch v-model="attribute.legend.show" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="位置(X)">
        <e-chart-position v-model="attribute.legend.x" :direction="'x'"/>
      </t-form-item>
      <t-form-item label="位置(Y)">
        <e-chart-position v-model="attribute.legend.y" :direction="'y'"/>
      </t-form-item>
      <t-form-item label="布局方式">
        <t-select size="small" v-model="attribute.legend.orient">
          <t-option label="纵向" value="vertical"/>
          <t-option label="横向" value="horizontal"/>
        </t-select>
      </t-form-item>
      <t-form-item label="字体">
        <t-input-number size="small" v-model="attribute.legend.textStyle.fontSize" :min="2" :max="120" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="文字颜色">
        <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.legend.textStyle.color"/>
      </t-form-item>
    </e-collapse>
    <e-collapse title="扇区" :expand="true">
      <t-form-item label="扇区样式">
        <t-switch v-model="attribute.series.roseType" :label="['玫瑰图', '平铺']" size="small"/>
      </t-form-item>
      <t-form-item label="外环占比">
        <t-input-number size="small" v-model="attribute.series.radius" :min="0.1" :max="1" :decimal-places="1" :step="0.1"/>
      </t-form-item>
      <t-form-item label="盒子高度">
        <t-input-number size="small" v-model="attribute.grid3D.boxHeight" :min="2" :max="20" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="饼图位置">
        <t-input-number size="small" v-model="attribute.grid3D.top" :min="-100" :max="200" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="自动旋转">
        <t-switch v-model="attribute.grid3D.viewControl.autoRotate" :label="['开', '关']" size="small"/>
      </t-form-item>
      <t-form-item label="旋转速度">
        <t-input-number size="small" v-model="attribute.grid3D.viewControl.autoRotateSpeed" :min="5" :max="500" :decimal-places="0"/>
      </t-form-item>
      <t-form-item label="配色">
        <e-color-group v-model="attribute.color" :max="20" :gradient="false"/>
      </t-form-item>
    </e-collapse>
  </t-form>
</template>

<script>
import EChartPosition from "@/components/designer/e-chart-position";
import EColorGroup from "@/components/designer/e-color-group";
import CptData from '@/components/element/options/comp/cpt-data'
export default {
  name: "cpt-chart-pie-3d-option",
  components: {EColorGroup, EChartPosition,CptData},
  props: { attribute: Object,cptDataForm:Object, },
}
</script>

<style scoped>
</style>
